import styles from './AreYouSureDialog.mobile.module.css';
import DialogView from '../../dialog/Dialog.view';
import { useTranslation } from 'react-i18next';
import type AreYouSureDialogProperties from '../AreYouSureDialog.properties.ts';

export default function AreYouSureDialogMobileView(props: AreYouSureDialogProperties) {
  const { t } = useTranslation();

  return (
    <DialogView header={t('ui.changeShelfLife')} moveToFront onBackdrop={props.handleNo}>
      <>
        <div className={styles.messageContainer}>
          <p className={styles.message}>{props.message}</p>
        </div>
        {props.children && <div>{props.children}</div>}
        <div className={styles.buttonContainer}>
          <button className={styles.buttonNo} onClick={props.handleNo}>
            {t('ui.no')}
          </button>
          <button
            className={styles.buttonYes}
            onClick={props.handleYes}
            disabled={props.disabledYes}
          >
            {t('ui.yes')}
          </button>
        </div>
      </>
    </DialogView>
  );
}
